export default __webpack_public_path__ + "static/media/flag-es-AR.829330d6.png";